import { Phone } from "lucide-react";

/** Scaffold: il canale telefonico si popolerà con il voice agent (M4). */
export function CanaleTelefono() {
  return (
    <div className="grid place-items-center rounded-xl border border-dashed bg-card px-6 py-14 text-center">
      <div className="mb-3.5 grid size-14 place-items-center rounded-2xl bg-muted">
        <Phone className="size-6 text-muted-foreground" />
      </div>
      <h3 className="text-base font-bold">Canale telefonico</h3>
      <p className="mx-auto mt-1.5 max-w-md text-sm text-muted-foreground">
        Qui arriveranno le chiamate gestite dagli agenti vocali: registro chiamate,
        trascrizione, audio e costo, con lo stesso schema scaricabile (PDF / JSON) di
        chat ed email.
      </p>
      <span className="mt-3 inline-block rounded-full bg-brand-50 px-3 py-1 text-xs font-semibold text-brand-700">
        Struttura pronta · si popola con il voice M4
      </span>
    </div>
  );
}
